import { render, staticRenderFns } from "./submitSign.vue?vue&type=template&id=244d68c0&scoped=true"
import script from "./submitSign.vue?vue&type=script&lang=js"
export * from "./submitSign.vue?vue&type=script&lang=js"
import style0 from "./submitSign.vue?vue&type=style&index=0&id=244d68c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d68c0",
  null
  
)

export default component.exports